import './accountDetailsForm';
import './accountCommunicationsForm';
import './utils';
import './accountCheckbox';


const showChangePassword = document.querySelector('[data-show-change-password]');
const showMainAddress = document.querySelector('[data-show-main]');
const mainContent = document.querySelector('[data-main-content]');


function toggleElementVisibility(element, isVisible) {
  element.classList.toggle('hidden', !isVisible);
  element.classList.toggle('md:flex', isVisible);
}

function showChangePasswordContent() {
  const changePasswordContent = document.querySelector('[data-change-password-content]');
  if (!changePasswordContent) return;

  toggleElementVisibility(mainContent, false);
  toggleElementVisibility(changePasswordContent, true);
}

function showMainAddressContent() {
  const changePasswordContent = document.querySelector('[data-change-password-content]');
  if (!changePasswordContent) return;

  toggleElementVisibility(mainContent, true);
  toggleElementVisibility(changePasswordContent, false);
}

showChangePassword?.addEventListener('click', showChangePasswordContent);
showMainAddress?.addEventListener('click', showMainAddressContent);


